import * as React from 'react';
import {
  DEFAULT_STREAM_ASPECT,
  pickFitMode,
  useStyles,
  VideoGamecastFitMode,
} from './styles';
import Box from '@mui/material/Box';
import { useEffect, useState } from 'react';
import { UnregisterTouchToMouse } from '@core/dashboard/components/DashboardContent/GameCast/touchtomouse';

const VideoGamecast = () => {
  const videoRef = React.useRef<HTMLVideoElement>(null);
  const [streamAspect, setStreamAspect] = useState<number>(
    DEFAULT_STREAM_ASPECT,
  );
  const [fitMode, setFitMode] = useState<VideoGamecastFitMode>('contain');

  const classes = useStyles(fitMode, streamAspect);

  useEffect(() => {
    return () => {
      const videoElement = document.getElementById('gamecastVideoTag');

      if (videoElement) {
        UnregisterTouchToMouse(videoElement);
      }
    };
  }, []);

  useEffect(() => {
    const video = videoRef.current;

    if (!video) {
      return;
    }

    const updateStreamAspect = () => {
      const { videoWidth, videoHeight } = video;

      if (videoWidth <= 0 || videoHeight <= 0) {
        return;
      }

      const nextAspect = videoWidth / videoHeight;

      setStreamAspect((current) => {
        if (Math.abs(current - nextAspect) < 0.001) {
          return current;
        }

        return nextAspect;
      });
    };

    video.addEventListener('loadedmetadata', updateStreamAspect);
    video.addEventListener('resize', updateStreamAspect);
    updateStreamAspect();

    return () => {
      video.removeEventListener('loadedmetadata', updateStreamAspect);
      video.removeEventListener('resize', updateStreamAspect);
    };
  }, []);

  useEffect(() => {
    const updateFitMode = () => {
      setFitMode((current) => {
        const next = pickFitMode(
          window.innerWidth,
          window.innerHeight,
          streamAspect,
        );

        return next === current ? current : next;
      });
    };

    updateFitMode();
    window.addEventListener('resize', updateFitMode);
    window.addEventListener('orientationchange', updateFitMode);

    return () => {
      window.removeEventListener('resize', updateFitMode);
      window.removeEventListener('orientationchange', updateFitMode);
    };
  }, [streamAspect]);

  return (
    <Box sx={classes.root}>
      <video
        ref={videoRef}
        playsInline
        autoPlay
        id="gamecastVideoTag"
        data-testid="gamelift-streams-video"
        muted
        onContextMenu={(event) => {
          event.preventDefault();
          return false;
        }}
        onPause={() => videoRef.current?.play()}
      ></video>
      <audio
        autoPlay
        muted
        id="gamecastAudioTag"
        data-testid="gamelift-streams-audio"
      />
    </Box>
  );
};

export default VideoGamecast;
